import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
// Change from default import to named import
import { msalConfig } from './authConfig'; // Correct the import here
import App from './App';
import './App.css';

const pca = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <MsalProvider instance={pca}>
    <App />
  </MsalProvider>
);
